



<ion-button class="notificationBtn" (click)="navigate()">
  <ion-badge size="small">{{ NotificationUnreadCount }}</ion-badge>
  <ion-icon name="notifications"></ion-icon>
</ion-button>
